export default "__VITE_ASSET__799d459d__"